var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.311 34.311"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.122 2.121L32.19 32.189m0-30.068L2.122 32.189",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 3
  })));
}
export default SvgXinline;